import { UIEventBufferStorage } from './UIEventBufferStorage';

// Local, not session, storage: a worker who loses signal may close the app or
// let the phone die before the next load.
const STORAGE_KEY = 'uiEventBuffer';

/**
 * Injected so tests can use an in-memory store.
 *
 * Every call is wrapped: `localStorage` throws when site data is blocked, and
 * `setItem` throws when full. An unreadable buffer reads as empty.
 */
export const createBrowserUIEventBufferStorage = (): UIEventBufferStorage => ({
  read: readBuffer,
  write: writeBuffer,
  clear: clearBuffer,
});

function readBuffer(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

function writeBuffer(value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // the event is lost, no worse than having no buffer
  }
}

function clearBuffer(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // never let tracking throw into the page
  }
}
